import { createContext } from 'react';

const TabsContext = createContext(null);

export default TabsContext;
